import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { siteConfig } from '../../data/mock';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Speaking', path: '/speaking' },
    { name: 'Ty the Mission', path: '/ty-the-mission' },
    { name: 'About', path: '/about' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled
          ? 'bg-[#0d0d0d]/95 backdrop-blur-md border-b border-[rgba(168,168,160,0.1)]'
          : 'bg-transparent'
      }`}
    >
      <div className="container-custom">
        <nav className="flex items-center justify-between h-20 md:h-24">
          {/* Logo */}
          <Link
            to="/"
            className="flex items-center hover:opacity-80 transition-opacity"
          >
            <img 
              src="https://customer-assets.emergentagent.com/job_1e5c107d-48e5-49a9-bc86-236f456dfd6e/artifacts/3hsl2ln5_Ty%20Logo2-03.png" 
              alt={siteConfig.name}
              className="w-auto invert brightness-100"
              style={{ height: '160px' }}
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium tracking-wide transition-colors ${
                  isActive(link.path)
                    ? 'text-[#c9a86c]'
                    : 'text-[#a8a8a0] hover:text-[#f5f5f0]'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <Link
              to="/book"
              className="btn-primary text-sm px-6 py-3"
            >
              Book Tyrre
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden p-2 text-[#f5f5f0] hover:text-[#c9a86c] transition-colors"
            aria-label="Toggle menu"
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </nav>
      </div>

      {/* Mobile Menu */}
      <div
        className={`md:hidden absolute top-full left-0 right-0 bg-[#0d0d0d]/98 backdrop-blur-md border-b border-[rgba(168,168,160,0.1)] transition-all duration-300 ${
          isMobileMenuOpen
            ? 'opacity-100 visible translate-y-0'
            : 'opacity-0 invisible -translate-y-4'
        }`}
      >
        <div className="container-custom py-6 flex flex-col gap-4">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`text-lg font-medium py-2 transition-colors ${
                isActive(link.path)
                  ? 'text-[#c9a86c]'
                  : 'text-[#a8a8a0] hover:text-[#f5f5f0]'
              }`}
            >
              {link.name}
            </Link>
          ))}
          <Link
            to="/book"
            className="btn-primary text-center mt-4"
          >
            Book Tyrre
          </Link>
        </div>
      </div>
    </header>
  );
};

export default Header;